import $ from "dabbyjs/src/core/dabby/dabby.js";
import search from "./search.js";
import toggle from "../../javascript/toggle-height.js";
import "../../javascript/accessibility.js";

export default obj => {
	if (obj.length) {
		const cls = obj.get(0).classList[0];
		toggle($("." + cls + "__category-label", obj));
		search(obj);
	}
}